import React from 'react'

import './index.scss'

export const CloseMenuIcon: React.FC = () => (
  <svg className="icon icon--close-menu" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path className="stroke" d="M14 6L6 14M6 6L14 14" strokeLinecap="square" />
  </svg>
)
